<template>
  <div class="online-paydetail">
    <div class="nav-bar">
      <i @click="goDepositHandle" class="el-icon-back icon-btn pointer"></i>
      <span @click="goDepositHandle" class="pointer">{{ currentChannel.channelName }}</span>
    </div>
    <div class="pay-detail">
      <div v-html="currentChannel.desc" class="tips-card">
        <div class="subtitle">{{$t('Precautions')}}</div>
        <div class="tips-p ql-container" v-html="currentChannel.desc"></div>
      </div>
      <div class="content-card">
        <div class="account-list-top-text">{{ $t('deposit_account') }}</div>
        <mtaccount-list ref="mtlist"></mtaccount-list>
        <div class="nav-title">{{ $t('Payment_currency') }}</div>
        <div class="tab-inner">
          <div class="tab-item" v-for="(item, index) in currencyList" :key="index" :class="{ on: item == currency }"
            :style="getActiveStyle(item)" @click="currencyHandle(item)">
            {{ item }}
          </div>
        </div>
        <div class="payee-info">
          <div class="h5">{{ $t('Billing_message') }}</div>
          <div class="gray-bgc-box">
            <div class="info-line key-data-line">
              <span class="left-span">{{ $t('Coin_deposit_address') }}</span>
              <span class="middle-span">{{ currentChannel.address }}</span>
              <i @click="copyHandle" class="iconfont icon-copy1 copy-btn"></i>
            </div>
            <div class="info-line">
              <span class="left-span">{{ $t('QR_code') }}</span>
              <el-image class="qrimg" :src="currentChannel.qrPic" alt="" :preview-src-list="[currentChannel.qrPic]">
              </el-image>
            </div>
            <div class="info-line">
              <span class="left-span">{{ $t('remark') }}</span>
              <span class="middle-span">{{ '-' }}</span>
            </div>
          </div>
        </div>
        <el-row>
          <el-col :lg="8" :sm="8" :xs="24">
            <el-form class="elform" ref="form" :model="form" :rules="rules" label-position="top">
              <el-form-item :label="$t('Amount_deposited')" prop="curentLimitMoney" class="has-prefix-item">
                <el-input :placeholder="amountTips" :value="form.curentLimitMoney" @blur="curentMoneyBlurHandle"
                  @input="inputHandle">
                  <span slot="prefix">USD</span>
                </el-input>
                <p>{{ $t('Trade.poundage') }}: {{ fee }}</p>
              </el-form-item>
              <el-form-item :label="$t('Trade.payMoney')" class="has-prefix-item">
                <el-input disabled :value="getTotalSum">
                  <span slot="prefix">{{ currency }}</span>
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('payment_voucher')" prop="voucherImgUrl">
                <upload-img-tips></upload-img-tips>
                <div>
                  <MobileImageUpload
                    :value="form.voucherImgUrl"
                    @input="(url) => { form.voucherImgUrl = url }"
                    @success="(url) => { form.voucherImgUrl = url }"
                  >
                    <img v-if="form.voucherImgUrl" :src="form.voucherImgUrl" class="avatar middle">
                    <div v-else class="avatar-uploader-btn voucherpicture">
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                  </MobileImageUpload>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Payer_wallet_address')" prop="walletAddress">
                <el-input :placeholder="$t('wallet_address')" v-model="form.walletAddress"></el-input>
              </el-form-item>
              <el-form-item :label="`${$t('Blockchain_transaction_ID')} (Hash)`" prop="hashAddress">
                <el-input :placeholder="$t('Hash_address_after_deposit_is_completed')"
                  v-model="form.hashAddress"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="sumbmitLoading" @click="payHandle">{{ $t('confirm_payment')
                }}</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { limitImageSizeFormat } from "@/utils/common";
import mtaccountList from "@/components/public/mtaccountList";
import copy from 'copy-to-clipboard'
import { colorRgba } from "@/utils";
import {
  EnterMoeny,
  getUSDExRateAndFee
} from '@/api/userCenter.js';
import { mapGetters } from 'vuex'
import { amountInputValidate, onlyTwoBitFloat } from "@/utils/validate";
export default {
  name: "index",
  components: {
    mtaccountList
  },
  data() {
    let _this = this;
    var validateMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('payChannel.inputMoney')));
      } else {
        if (!onlyTwoBitFloat(value)) {
          callback(new Error(this.$t('User.onlyInputTwoBitNumber')));
          this.$emit('request-err');
          return;
        } else {
          callback();
        }
      }
    };
    return {
      // 后台取文字提示 todo
      tips: [
        '1.汇款完成后，请在数字货币钱包的提现记录里，将附带完整哈希地址的汇款凭证的截图，上传到汇款凭证处。',
      ],
      currency: '',
      // 表单
      form: {
        curentLimitMoney: '',
        totalAmount: '',
        voucherImgUrl: '',
        walletAddress: '',
        hashAddress: '',
      },
      rules: {
        curentLimitMoney: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validateMoney, trigger: 'blur' },
        ],
        voucherImgUrl: [
          { required: true, message: _this.$t('Please_upload_payment_voucher'), trigger: 'change' },
        ],
        walletAddress: [
          /*{ required: true, message: '请输入钱包地址,没有则天无', trigger: 'blur' },*/
        ],
        hashAddress: [
          /*{ required: true, message: _this.$t('Please_enter_the_Hash_address_after_the_transaction'), trigger: 'blur' },*/
        ],
      },
      currentChannel: {
        currency: '',
        qrPic: '',
        address: '',
        minimumLimit: '',
      },
      exchangeRate: '',
      sumbmitLoading: false,

      voucherLoading: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'realMobile', 'themeColor']),
    currencyList() {
      let currentArr = this.currentChannel.currency.split(',');
      return currentArr;
    },
    amountTips() {
      let minLimit = '';
      if (this.currency.includes('CNY')) {
        minLimit = Math.floor(this.currentChannel.minimumLimit / this.exchangeRate);
      } else {
        minLimit = this.currentChannel.minimumLimit;
      }
      return `≥${minLimit}`
    },
    //手续费
    fee() {
      // 保留两位小数
      let feeTotal = (this.currentChannel.feeValue * this.form.curentLimitMoney).toFixed(2);
      return feeTotal;
    },
    rate() {
      return this.currentChannel.nominalExRateDeposit;
    },
    // 没算手续费的总额,
    getTotalSum() {
      if (this.form.curentLimitMoney == '' || !Number(this.form.curentLimitMoney)) {
        return `0`;
      }
      // 选择USD
      if (this.currentChannel.payPlatformName === 'bft' || this.currentChannel.payPlatformName === 'uEnjoy' || this.currentChannel.payPlatformName === 'BipiPay') {
        return Math.ceil(this.form.curentLimitMoney * this.exchangeRate);
      } else {
        return (this.form.curentLimitMoney * this.exchangeRate).toFixed(2);
      }
    },
  },
  created() {
    this.getChannelList();
  },
  mounted() {
    let reouterview = document.getElementById('routerview');
    reouterview.classList.add('no-padding-import');
  },
  beforeDestroy() {
    let reouterview = document.getElementById('routerview');
    reouterview && reouterview.classList.remove('no-padding-import');
  },
  methods: {
    curentMoneyBlurHandle() {
      this.queryExchangeRate();
    },
    inputHandle(val) {
      this.form.curentLimitMoney = amountInputValidate(val);
    },
    getChannelList() {
      getUSDExRateAndFee({
        oprType: 1,
        payType: 3,
      }).then((res) => {
        this.queryExchangeRate();
        if (res.data.length) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].channelCode == this.$route.params.channelCode) {
              this.currentChannel = res.data[i];
              this.currency = this.currencyList[0];
              break;
            }
          }
        }
      })
    },
    queryExchangeRate() {
      let params = {
        oprType: 1,
        payType: 3,
        channelCode: this.$route.params.channelCode,
      }
      if (this.form.curentLimitMoney) {
        let finalAmount = (this.form.curentLimitMoney + '');
        let finalBillAmount = (((this.form.curentLimitMoney * this.rate).toFixed(2)) + '');
        params.amount = finalAmount;
        params.billAmount = finalBillAmount;
      }
      getUSDExRateAndFee(params).then((res) => {
        this.exchangeRate = res.data[0].nominalExRateDeposit;
      })
    },
    uploadImgUrlHandle(item) {

      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);
        this.voucherLoading = true;
        this.$uploadFile(file).then((res) => {
          this.voucherLoading = false;
          this.form.voucherImgUrl = res.data.data.content[0].url;
        }).catch((err) => {
          this.voucherLoading = false;
        })
      });

    },
    // 上传图片的限制
    beforeImgUpload(file) {

      return limitImageSizeFormat(file, this);
    },
    getLabel(item) {
      return `'MT4' (${item.login}) ${this.$t('balance')}: ${item.balance}`
    },
    getActiveStyle(item) {
      if (item == this.currency) {
        return {
          backgroundColor: colorRgba(this.themeColor, 0.1),
        }
      }
    },
    currencyHandle(item) {
      this.currency = item;
    },
    copyHandle() {
      this.$message({
        type: 'success',
        message: this.$t('User.copySuccess')
      });

      copy(this.currentChannel.address);
    },
    payHandle(item) {

      this.$refs.form.validate((valid) => {
        if (valid) {
          //  本地汇款：确认支付跳转第三方页面，本页面变成【提交成功】
          this.enterGolden();
        } else {
          console.log('no-pass');
        }
      })
    },
    enterGolden() {
      // 需加入新的字段
      if (!this.$refs.mtlist.curLogin) {
        return;
      }
      if (!this.form.curentLimitMoney) {
        return;
      }
      // 先查询汇率接口在调入金接口
      let finalAmount = (this.form.curentLimitMoney + '');
      let finalBillAmount = (((this.form.curentLimitMoney * this.rate).toFixed(2)) + '');
      getUSDExRateAndFee({
        oprType: 1,
        payType: 3,
        channelCode: this.currentChannel.channelCode,
        amount: finalAmount,
        billAmount: finalBillAmount,
      }).then((res) => {
        this.exchangeRate = res.data[0].nominalExRateDeposit;
        let realTimeRealExRateDeposit = res.data[0].realExRateDeposit;
        let mtlist = this.$refs.mtlist;
        let parmas = {
          custId: this.userInfo.id,
          serverId: mtlist.currentMt4Info.serverId,
          login: mtlist.currentMt4Info.login,
          group: mtlist.currentMt4Info.group,
          currency: this.currentChannel.currency,
          payType: this.currentChannel.channelCode,
          realExRate: realTimeRealExRateDeposit,
          nominalExRate: this.exchangeRate,
          type: 1,
          // 支付凭证
          payPic: this.form.voucherImgUrl,
          payerAddress: this.form.walletAddress,
        };
        if (this.form.hashAddress) {
          parmas.tradeHash = this.form.hashAddress;
        }
        parmas.amount = ((this.form.curentLimitMoney / this.exchangeRate).toFixed(2)) + '';
        parmas.billAmount = this.form.curentLimitMoney + '';
        this.sumbmitLoading = true;
        EnterMoeny(parmas).then((res) => {
          this.sumbmitLoading = false;
          this.$router.push({ name: 'successSubmit' }).catch(() => {
            window.location.href = this.$router.resolve({ name: 'successSubmit' }).href;
          });
        }).catch((err) => {
          console.log(err);
          this.sumbmitLoading = false;
        })
      })
    },
    goDepositHandle() {
      this.$router.push({ name: 'depositFunds' });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variable";

.online-paydetail {
  .avatar-uploader {
    /deep/ .el-upload {
      width: 100px;
      min-height: 120px;
      display: flex;
      justify-content: center;
      /* 水平居中 */
      align-items: center;
      /* 垂直居中 */
    }
    .avatar {
      width: 100px;
      // height: 120px;
    }
  }

  .avatar-uploader-btn {
    width: 100px;
    height: 70px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 2px dashed #D8D6DE;
  }


  .avatar-uploader {

    text-align: left;

    .voucherpicture {
      width: 100px;
      height: 120px;
      box-sizing: border-box;
      border: 2px dashed #D8D6DE;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #B9B9C3;

      .el-icon-plus {
        font-size: 16px;
        font-weight: 600;
      }
    }
  }

  .nav-bar {

    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;

    .icon-btn {
      font-size: 16px;
    }
  }

  .payee-info {
    .h5 {
      margin-bottom: 15px;
    }

    .gray-bgc-box {
      background-color: #F8F8F8;
      padding: 20px 0;
      margin-bottom: 20px;
    }

    .info-line {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin-left: 20px;
      margin-bottom: 15px;

      .copy-btn {
        margin-left: 20px;
        cursor: pointer;
        color: #B9B9C3;
      }

      .key-data-line {
        .middle-span {
          color: #5E5873;
        }
      }

      .qrimg {
        width: 80px;
        height: 80px;
      }

      .left-span {
        color: #A29FAE;
        padding-right: 10px;
        text-align: left;
      }
    }
  }



  .pay-detail {
    padding: 24px;

    .tips-card,
    .content-card {
      background-color: #ffffff;
      border-radius: 10px;
      margin-bottom: 24px;
      padding: 24px;

      .elform {
        .has-prefix-item {
          /deep/ .el-input__inner {
            padding-left: 60px;
          }

          /deep/ .el-input__prefix {
            left: 16px
          }
        }

      }
    }

    .subtitle {
      font-size: 16px;
      font-weight: 600;
      color: #5E5873;
      margin-bottom: 20px;
    }

    .tips-card {
      .tips-p {
        color: #5E5873;
      }
    }

    .account-inner {
      border: 1px solid #EBE9F1;
      border-radius: 5px;
      padding: 10px;
      cursor: pointer;

      &.active {
        border-color: $themeColor;
      }

      .account-top {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .login {
          padding-left: 10px;
          font-size: 14px;
          font-weight: 600;
          color: #6E6B7B;
        }
      }

      .inner-bot {
        padding-left: 30px;
        margin-top: 5px;
      }

      .small-icon {
        width: 24px;
        height: 24px;
      }
    }

    .nav-title {
      margin-top: 30px;
      margin-bottom: 15px;
    }
  }

  .mobile-row {

    .el-dropdown,
    .account-inner {
      width: 100%;
    }
  }
}
</style>
